import { firebaseRemoteConfig } from '@src/config';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { useAppStore } from '@src/shared/zustand/store';
import { FaqItem } from './faq.types';
import { ApiError } from '@src/shared/models';

export const setFaqData = (data: FaqItem[]) =>
  useAppStore.setState({ faqData: data });

export const clearFaqData = () => useAppStore.setState({ faqData: null });

export const getFaqData = async (
  callback: (error: ApiError | null) => void
) => {
  try {
    await fetchAndActivate(firebaseRemoteConfig);

    const fetchedValue = getValue(firebaseRemoteConfig, 'faq');
    const parsedData = JSON.parse(fetchedValue.asString()).data;

    setFaqData(parsedData);
    callback(null);
  } catch (error) {
    callback(error);
  }
};
